var map = {
	"./8fd3caf5f68e67fdbb1d8bb99963c50.jpg": 1025,
	"./f913055a18c9723f769433675b8ebc8.jpg": 8261,
	"./莱州云峰水厂.jpg": 1212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9983;